import Vue from "vue";
import ToastComponent from "./Toast.vue";

const ToastConstructor = Vue.extend(ToastComponent);

let instance = null;

function showToast(message, duration = 1500) {
  removeToast();

  instance = new ToastConstructor();
  instance.$mount(document.createElement("div"));
  document.body.appendChild(instance.$el);
  instance.show(message, duration);

  instance._timer = setTimeout(() => {
    removeToast();
  }, duration + 500); // 500ms for fade out
}

const removeToast = () => { 
  if (instance?.$el) {
    clearTimeout(instance._timer);
    instance.$destroy();
    document.body.removeChild(instance.$el);
    instance = null;
  }
}

export default {
  install(Vue) {
    Vue.prototype.$toast = showToast;
  },
};

export const Toast = showToast;